export { default } from "./connected";
